// This is based on the assumption that all views are at pages under "plugin/auth2/*"
import '@elo/ui-buefy-v3/dist/elo-ui.css'
import '@elo/font-elo-sans-pro'
import '../css/sign-in.css'
import '../css/e-icons.css';
import {API_URL} from "./utils"; // EAUTH2-33


document.body.style.backgroundImage = `url('${API_URL}/branding/background')`;
